<template>
  <div class="body">
    <img
      :src="banner"
      class="banner"
      @click="gonews(2)"
    />
    <div class="body-inset">
      <div class=""></div>
      <div class="msg-box" style="background: #F0F0F0;width:100%;padding-top:91px;padding-bottom:65px;">
        <div class="msg-box-title">
          製品、サービス取扱説明書
        </div>
        <div class="msg-box-inset">
          <div class="msg-box-min">
            <img :src="min0" />
             <a href="./static/instructions1.pdf" download="instructions1">
              <div
                class="msg-box-btn"
                type="orange"
              >
                ダウンロード
              </div>
             </a>
          </div>
          <div class="msg-box-min">
            <img :src="min1" />
            <a href="./static/instructions2.pdf" download="instructions2">
              <div
                class="msg-box-btn"
                type="green"
              >
                ダウンロード
              </div>
            </a>
          </div>
          <div class="msg-box-min">
            <img :src="min2" />
            <a href="./static/instructions3.pdf" download="instructions3">
              <div
                class="msg-box-btn"
                type="orange"
              >
                ダウンロード
              </div>
            </a>
          </div>
          <div class="msg-box-min">
            <img :src="min3" />
             <a href="./static/instructions4.pdf" download="instructions4">
              <div
                class="msg-box-btn"
                type="blue"
              >
                ダウンロード
              </div>
             </a>
          </div>
        </div>
      </div>
      <div class="title">
        J-DIRECT Q&A
      </div>
      <div class="q-a" v-for="(a, index) in agent">
        <div class="question" style="font-family:middle;">
          {{a.Q}}
        </div>
        <div class="answer" style="font-family:light;">
          {{a.A1}}
        </div>
        <div class="answer" style="font-family:light;">
          {{a.A2}}
        </div>
        <div class="answer" style="font-family:light;">
          {{a.A3}}
        </div>
      </div>
      </div>
      <!-- <div class="agent-store-outer">
        <div class="agent-title">
          海外販売代理店一覧
        </div>
        <div class="agent-store">
          <div class="agent-inset">
            <div class="agent-store-title">
              欧州
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
          </div>
          <div class="agent-inset">
            <div class="agent-store-title">
              中東
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
          </div>
          <div class="agent-inset">
            <div class="agent-store-title">
              アジア
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
          </div>
          <div class="agent-inset">
            <div class="agent-store-title">
              北米
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
          </div>
          <div class="agent-inset">
            <div class="agent-store-title">
              豪州
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
          </div>
          <div class="agent-inset">
            <div class="agent-store-title">
              アフリカ
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
            <div class="agent-store-inset">
              欧州代理店
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { banner, min0, min1, min2, min3 } from '../../images/agent/index'
import agent from '../../data-js/agent/index'
export default {
  data () {
    return {
      banner,
      min0,
      min1,
      min2,
      min3,
      agent
    }
  },
  methods: {
    gonews(id){
      this.$router.push('/news?id='+id)
    }
  }
}
</script>
<style scoped>
.banner {
  display: block;
  width: 100%;
  min-width: 1100px;
  cursor:pointer;
}
.body-inset {
  width: 100%;
  min-width: 1100px;
  padding: 1px 0;
}
.title {
  font-size: 35px;
  text-align: center;
  color: #02d8c9;
  font-weight: bold;
  margin-top: 30px;
}
.q-a {
  width: 1100px;
  margin: 0 auto;
  margin-bottom: 30px;
  margin-top: 30px;
  box-sizing: border-box;
  padding-left: 70px;
}
.question {
  position: relative;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.question::before {
  content: 'Q';
  position: absolute;
  color: #fff;
  font-weight: normal;
  text-align: center;
  left: -40px;
  /* top: 10px; */
  width: 30px;
  height: 30px;
  font-size: 20px;
  text-align: center;
  line-height: 30px;
  background: #02d8c9;
}
.answer {
  font-size: 16px;
  color: #4b4b4b;
}
.msg-box {
  width: 1100px;
  margin: 0 auto;
}
.msg-box-title {
  font-weight: bold;
  font-size: 32px;
  text-align: center;
  color: #222;
  margin-bottom: 30px;
}
.msg-box-inset {
  width: 900px;
  margin: 0 auto;
  display: flex;
}
.msg-box-min {
  flex: 1;
  margin: 0 12.5px;
}
.msg-box-min img {
  display: block;
  width: 200px;
}
.msg-box-btn {
  font-size: 15px;
  height: 25px;
  width: 120px;
  line-height: 25px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 25px;
  border: solid 1px #222;
  font-weight: bold;
  cursor: pointer;
}
.msg-box-btn[type='orange'] {
  border-color: #ea561d;
}
.msg-box-btn[type='green'] {
  border-color: #42b3b0;
}
.msg-box-btn[type='blue'] {
  border-color: #2eb5e7;
}
.agent-store-outer {
  width: 100%;
  min-width: 1100px;
  background: #e5e5e5;
  padding: 50px 0;
  margin-top: 50px;
}
.agent-title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
}
.agent-store {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  font-size: 25px;
  justify-content: space-between;
  text-align: center;
  margin-top: 15px;
}
.agent-store-title {
  font-weight: bold;
}
.agent-store-inset {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/agent/index.vue